import type Swiper from "swiper"

export const scrollThumbIntoView = (
  thumbsSwiper: Swiper | undefined,
  index: number
) => {
  if (!thumbsSwiper || thumbsSwiper.destroyed) return

  const isVisible = thumbsSwiper.slides[index]?.classList.contains(
    thumbsSwiper.params.slideVisibleClass ?? "swiper-slide-visible"
  )
  if (isVisible) return

  thumbsSwiper.slideTo(index)
}
